/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
// eslint-disable-next-line @sail/data-no-imperative-methods
import {ApolloLink, Observable} from '@apollo/client';
import {isValidSentryTeamName} from '../../utils/getTeamForComponent';
import {
  reportQueryOrMutationError,
  reportQueryOrMutationSuccess,
} from '../../utils/telemetry/connectElementAnalyticsSender';
import type {ReportError} from '../../utils/errorHandling';
import {makeSafe} from '../../utils/errorHandling';
import type {IAnalyticsSender} from '../../data-layer-frame/AnalyticsTypes';
import type {HostApp} from '../../connect/ConnectJSInterface/InitAndUpdateOptionsTypes';

export default function createReportErrorOrSuccessLink({
  connectElementAnalyticsSender,
  reportError,
  hostApp,
}: {
  connectElementAnalyticsSender: IAnalyticsSender;
  reportError: ReportError;
  hostApp: HostApp;
}) {
  return new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const startTime = window.performance.now();

    const queryProject = isValidSentryTeamName(context?.queryProject)
      ? context.queryProject
      : undefined;

    const component = context?.component
      ? makeSafe(context?.component)
      : undefined;

    return new Observable((observer) => {
      return forward(operation).subscribe({
        next(data) {
          const duration = Math.ceil(window.performance.now() - startTime);

          if (data.errors) {
            data.errors.forEach((error) => {
              reportQueryOrMutationError(
                connectElementAnalyticsSender,
                reportError,
                error,
                operation.operationName,
                hostApp,
                context?.expectedErrors,
                context?.mutedErrors,
                undefined,
                duration,
                queryProject,
                component,
              );
            });
          } else {
            reportQueryOrMutationSuccess(
              connectElementAnalyticsSender,
              operation.operationName,
              duration,
              queryProject,
              component,
            );
          }

          return observer.next(data);
        },

        error(error) {
          const duration = Math.ceil(window.performance.now() - startTime);

          reportQueryOrMutationError(
            connectElementAnalyticsSender,
            reportError,
            error,
            operation.operationName,
            hostApp,
            context?.expectedErrors,
            context?.mutedErrors,
            undefined,
            duration,
            queryProject,
            component,
          );

          observer.error(error);
        },

        complete() {
          observer.complete();
        },
      });
    });
  });
}
